import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import MobileSelect from "@/components/drill/MobileSelect";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const ROLES = ["Driller/Supervisor", "Trainee Driller", "Offsider", "Geologist"];
const ROLE_OPTIONS = ROLES.map((r) => ({ value: r, label: r }));

export default function SignatorySplash({ open, onOpenChange, onSave }) {
  const [form, setForm] = useState({ name: "", role: "", signature: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm({ name: "", role: "", signature: "" });
  }, [open]);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setSaving(true);
    try {
      await onSave(form);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle>Add signature</DialogTitle>
          <DialogDescription>Enter the signatory details to add to this hole.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSave} className="space-y-4 pt-1">
          <div>
            <Label>Name</Label>
            <Input
              value={form.name}
              onChange={(e) => set("name", e.target.value)}
              className="rounded-xl"
              placeholder="Full name"
              autoFocus
            />
          </div>
          <div>
            <Label>Role</Label>
            <MobileSelect
              value={form.role}
              onValueChange={(v) => set("role", v)}
              options={ROLE_OPTIONS}
              placeholder="Select role"
            />
          </div>
          <div>
            <Label>Signature</Label>
            <Input
              value={form.signature}
              onChange={(e) => set("signature", e.target.value)}
              className="rounded-xl italic"
              placeholder="Type your name to sign"
            />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl">
              Cancel
            </Button>
            <Button type="submit" disabled={saving} className="rounded-xl bg-slate-900 hover:bg-slate-800 gap-2">
              {saving && <Loader2 className="w-4 h-4 animate-spin" />} Add Signature
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}